import type { ColumnsType } from 'antd/lib/table'
import { AdminSaleOfferGroup } from '../models'
import {
  CustomHeaderText,
  FormLabels,
  CustomTitle
} from 'src/components'

const saleOfferGroupColumns: ColumnsType<AdminSaleOfferGroup> = [
  {
    title: () => <CustomHeaderText text='SalesOffer.GroupNameSale' />,
    responsive: ['sm'],
    sorter: (a, b) => a.name.length - b.name.length,
    className: 'pointer-cursor',
    render: (_, group) => <CustomTitle label={group.name} type={null} />
  },
  {
    title: () => <CustomHeaderText text='SalesOffer.SaleOffersCount' isCentered />,
    responsive: ['sm'],
    className: 'pointer-cursor',
    sorter: (a, b) => a.sale_offers.length - b.sale_offers.length,
    render: (_, group) => <div className='centered'>
      <CustomTitle label={group.sale_offers.length} type={null} />
    </div>
  },
  {
    title: () => <CustomHeaderText text='SalesOffer.Group' />,
    responsive: ['xs'],
    className: 'pointer-cursor',
    sorter: (a, b) => a.name.length - b.name.length,
    render: (_, group) => {
      return <FormLabels
        title={group.name}
        subtitle={`${group.sale_offers.length} sale offers`}
      />
    }
  },
]

export default saleOfferGroupColumns
